var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98633 12.5635L7.05299 14.1635C7.31966 14.4301 7.91966 14.5635 8.31966 14.5635H10.853C11.653 14.5635 12.5197 13.9635 12.7197 13.1635L14.3197 8.29681C14.653 7.36347 14.053 6.56347 13.053 6.56347H10.3863C9.98633 6.56347 9.65299 6.23014 9.71966 5.76347L10.053 3.63014C10.1863 3.03014 9.78633 2.36347 9.18633 2.16347C8.65299 1.96347 7.98633 2.23014 7.71966 2.63014L4.98633 6.69681",
    stroke: "#888888",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58594 12.5634V6.03009C1.58594 5.09676 1.98594 4.76343 2.91927 4.76343H3.58594C4.51927 4.76343 4.91927 5.09676 4.91927 6.03009V12.5634C4.91927 13.4968 4.51927 13.8301 3.58594 13.8301H2.91927C1.98594 13.8301 1.58594 13.4968 1.58594 12.5634Z",
    stroke: "#888888",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.814d4f9ee2d47258547762d5785df759.svg";
export { ForwardRef as ReactComponent };